import { fun_PostAction } from "@/api";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 表单基础数据
      formDataList: [
        {
          label: "项目名称",
          value: "prjName",
        },
        {
          label: "招标项目名称",
          value: "tenderPrjName",
        },
        {
          label: "招标类别",
          value: "tenderClassName",
          children: [
            {
              label: "招标内容",
              value: "tenderContentName",
            }
          ]
        },
        {
          label: "招标方式",
          value: "tenderTypeName",
          children: [
            {
              label: "招标项目类型",
              value: "tenderProjectTypeName",
            }
          ]
        },
        {
          label: "标段数/采购包",
          value: "sectionQuantity",
          children: [
            {
              label: "对投标人资格审查方式",
              value: "prequalificationTypeName",
            }
          ]
        },
        {
          label: "资格预审办法",
          value: "prequalificationMethodName",
        },
        {
          label: "立项批准文号",
          value: "noteNumber",
          children: [
            {
              label: "项目审批文件名称",
              value: "approvalName",
            }
          ]
        },
        {
          label: "评标办法",
          value: "evaluationMethodName",
        },
        {
          label: "是否需要项目负责人/总监",
          value: "isNeedPmName",
          children: [
            {
              label: "行政监督部门",
              value: "regulatorsName",
            }
          ]
        },
        {
          label: "项目容缺登记",
          value: "projectVacancyRegistrationName",
          children: [
            {
              label: "资金性质",
              value: "fundingSourceName",
            }
          ]
        },
        {
          label: "招标人",
          value: "tenderCorpName",
        },
        {
          label: "招标联系人",
          value: "tenderLinkMan",
          children: [
            {
              label: "招标联系人手机",
              value: "tenderLinkPhone",
            }
          ]
        },
        {
          label: "招标代理",
          value: "agencyCorpName",
        },
        {
          label: "招标代理联系人",
          value: "agencyLinkMan",
          children: [
            {
              label: "招标代理手机",
              value: "agencyLinkPhone",
            }
          ]
        },
        {
          label: "是否允许联合体下载",
          value: "isUnionCorpEnrollName",
          children: [
            {
              label: "招标单位是否联合体",
              value: "isUnionTenderName",
            }
          ]
        },
      ],
    }
  },
  // 监听事件
  watch: {
    // 监听form数据
    formData: {
      handler(newVal) {
        // 获取数据
        this.formData = newVal;
      },
      immediate: true // 立即执行
    },
  },
  // 接收来自父组件的数据
  props: {
    // form数据
    formData: {
      type: Object,
      default: () => {
        return { }
      }
    },
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 确认按钮
     */
    fun_GetVerify(){
      // 向父组件传递方法
      this.$emit("fun_GetVerify");
    },
  }
}